/** @format */

import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { ROUTES } from '../constant/routes';
import { useAuthStore } from '../context/useAuthStore';
import ProtectedRoute from './ProtectedRoute';
import DashboardLayout from '../components/layouts/DashboardLayout';

import LoginPage from '../pages/Auth/LoginPage';
import RegisterPage from '../pages/Auth/RegisterPage';
import ForgotPasswordPage from '../pages/Auth/ForgotPasswordPage';
import DashboardPage from '../pages/dashboard';
import SubjectPage from '../pages/subject';
import ProfilePage from '../pages/profile';
import AnswerPage from '../pages/dashboard/AnswerPage';
import ResetPasswordPage from '../pages/Auth/ResetPassword';
import SuperAdminDashboardPage from '../pages/superadmin/dashboard';
import CreateAdminUserPage from '../pages/superadmin/create-admin-user';
import SuperAdminProfilePage from '../pages/superadmin/profile';
import StudentsPage from '../pages/superadmin/students';
import RefundPolicy from '../pages/legal/refund_policy';
import TermsAndConditions from '../pages/legal/terms_conditions';
import Disclaimer from '../pages/legal/disclaimer';
import PrivacyPolicy from '../pages/legal/privacy_policy';
import ShippingPolicy from '../pages/legal/shipping_policy';
import ContactUs from '../pages/legal/contact-us';
import CheckOutPage from '../pages/checkout';
import SuperAdminDashboardLayout from '../components/layouts/SuperAdminDashboardLayout';
import LandingPage from '../pages/landing/LandingPage';
import BlogDetail from '../pages/blog/BlogDetail';
import Blogs from '../pages/blog/Blogs';
import Mentors from '../pages/mentors/Mentors';
import AdminDashboardLayout from '../components/layouts/AdminDashboardLayout';
import AdminDashboardPage from '../pages/admin/dashboard';
import CreateBlogPostPage from '../pages/admin/create-blog-post';
import ListAllBlogsPage from '../pages/admin/list-all-blogs';
import EditBlogPostPage from '../pages/admin/list-all-blogs/edit-blog';
import AllSubject from '../pages/subjects/subjectPage';
import SubjectDetail from '../pages/subjects/subjectDetailPage';

const AppRoutes: React.FC = () => {
	const fetchCurrentUser = useAuthStore((state) => state.fetchCurrentUser);

	useEffect(() => {
		fetchCurrentUser();
	}, [fetchCurrentUser]);

	return (
		<Routes>
			{/* Public Routes */}
			<Route
				path={ROUTES.HOME}
				element={<LandingPage />}
			/>
			<Route
				path={ROUTES.LOGIN}
				element={<LoginPage />}
			/>
			<Route
				path={ROUTES.REGISTER}
				element={<RegisterPage />}
			/>
			<Route
				path={ROUTES.FORGOT_PASSWORD}
				element={<ForgotPasswordPage />}
			/>
			<Route
				path={ROUTES.BLOGS}
				element={<Blogs />}
			/>
			<Route
				path={ROUTES.BLOG_DETAILS(':slug')}
				element={<BlogDetail />}
			/>
			<Route
				path={ROUTES.MENTORS}
				element={<Mentors />}
			/>
			<Route
				path={ROUTES.ALL_SUBJECTS}
				element={<AllSubject />}
			/>
			<Route
				path={ROUTES.SUBJECT_DETAIL(':slug')}
				element={<SubjectDetail />}
			/>
			<Route
				path={ROUTES.RESET_PASSWORD}
				element={<ResetPasswordPage />}
			/>
			<Route
				path={ROUTES.CONTACT_US}
				element={<ContactUs />}
			/>
			<Route
				path={ROUTES.PRIVACY_POLICY}
				element={<PrivacyPolicy />}
			/>
			<Route
				path={ROUTES.TERMS_AND_CONDITIONS}
				element={<TermsAndConditions />}
			/>
			<Route
				path={ROUTES.REFUND_POLICY}
				element={<RefundPolicy />}
			/>
			<Route
				path={ROUTES.SHIPPING_POLICY}
				element={<ShippingPolicy />}
			/>
			<Route
				path={ROUTES.DISCLAIMER}
				element={<Disclaimer />}
			/>

			{/* Protected Routes with Dashboard Layout */}
			<Route element={<ProtectedRoute />}>
				<Route element={<DashboardLayout children={undefined} />}>
					<Route
						path={ROUTES.DASHBOARD}
						element={<DashboardPage />}
					/>
					<Route
						path={ROUTES.DASHBOARD + '/:questionReference'}
						element={<AnswerPage />}
					/>
					<Route
						path={ROUTES.SUBJECT}
						element={<SubjectPage />}
					/>
					<Route
						path={ROUTES.PROFILE}
						element={<ProfilePage />}
					/>
					<Route
						path={ROUTES.CHECKOUT}
						element={<CheckOutPage />}
					/>
				</Route>
				<Route element={<SuperAdminDashboardLayout children={undefined} />}>
					{/* Super Admin Routes */}
					<Route
						path={ROUTES.SUPERADMIN_DASHBOARD}
						element={<SuperAdminDashboardPage />}
					/>
					<Route
						path={ROUTES.CREATE_ADMIN_USER}
						element={<CreateAdminUserPage />}
					/>
					<Route
						path={ROUTES.SUPERADMIN_STUDENTS}
						element={<StudentsPage />}
					/>
					<Route
						path={ROUTES.SUPERADMIN_PROFILE}
						element={<SuperAdminProfilePage />}
					/>
				</Route>
				<Route element={<AdminDashboardLayout children={undefined} />}>
					<Route
						path={ROUTES.ADMIN_DASHBOARD}
						element={<AdminDashboardPage />}
					/>
					<Route
						path={ROUTES.CREATE_BLOG_POST}
						element={<CreateBlogPostPage />}
					/>
					<Route
						path={ROUTES.ALL_BLOG_POSTS}
						element={<ListAllBlogsPage />}
					/>
					<Route
						path={ROUTES.EDIT_BLOG_POST}
						element={<EditBlogPostPage />}
					/>
					<Route
						path={ROUTES.ADMIN_PROFILE}
						element={<div>Admin Profile Page</div>}
					/>
				</Route>
			</Route>

			{/* Fallback Route */}
			<Route
				path='*'
				element={<div>Page Not Found</div>}
			/>
		</Routes>
	);
};

export default AppRoutes;
